import { composeIO } from 'react-compose-io'
import { itemListaParceirosIO } from './ItemListaParceiros.IO'
import { ItemListaParceirosView } from './ItemListaParceiros.View'

export const ItemListaParceiros = composeIO(ItemListaParceirosView, itemListaParceirosIO)
